//Modules
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom'; 
import { useTransition } from '../globalComponents/PageTransitionContext';

//Components
import { MenuPage } from '../menuPage/MenuPage';

//Styles
import './NavigationBar.css';
import logo from '../images/logo.webp';

export const NavigationBar = ({ className }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [overlayVisible, setOverlayVisible] = useState(false);
    const { handleNavigation } = useTransition();
    const location = useLocation(); 

    const toggleMenu = () => {
        setMenuOpen(prevState => !prevState);
        setOverlayVisible(!overlayVisible);
    };

    const navItems = [
        { name: 'Home', path: '/' },
        { name: 'About Me', path: '/AboutMe' },
        { name: 'Other Stuff', path: '/OtherStuff' },
        { name: 'Contact', path: '/ContactMe' },
    ];

    const handleLinkClick = (path) => {
        handleNavigation(path);
    };

    return (
        <div className="navbar-container">            
            <nav className="desktop-navbar">
                <div className="logo-container logo">
                <Link to="/" data-cursor-none onClick={(e) => {
                    if (location.pathname === "/") {
                        e.preventDefault(); 
                    } else {
                        handleLinkClick("/");
                    }
                }}>
                    <img src={logo} alt="Logo" />
                </Link>
                </div>

                <div className="link-list">
                    {navItems.map((item, index) => {
                        const isActive = location.pathname === item.path; 
                        return (
                            <div key={index}>
                                <Link
                                    className={`body desktop-menu-item ${isActive ? 'active' : ''}`} 
                                    to={item.path}
                                    data-cursor-none
                                    onClick={(e) => {
                                        if (!isActive) {
                                            e.preventDefault();
                                            handleLinkClick(item.path);
                                        }
                                    }}
                                    style={isActive ? { pointerEvents: 'none' } : {} } 
                                >
                                    {item.name}
                                </Link>
                            </div>
                        );
                    })}
                </div>
            </nav>

            {/* Mobile navbar */}
            <div className="mobile-navbar full-width">
                <div className="logo">
                    <Link to="/" onClick={(e) => {
                        if (location.pathname === "/") {
                            e.preventDefault(); 
                        } else {
                            handleLinkClick("/");
                        }
                    }}>
                        <img src={logo} alt="Logo" />
                    </Link>
                </div>
                <button onClick={toggleMenu} className="navbar-menu heading-5">
                    {menuOpen ? 'Close' : 'Menu'}
                </button>
                {menuOpen && <MenuPage onClose={() => setMenuOpen(false)} />}
            </div>

        </div>
    );
};
